import React, { useState } from 'react';
import FormFields from './FormFields';
import personalInformationValidationSchema from './personalInformationValidationSchema';
import { connect } from 'react-redux';
import axios from 'axios';
import { Toast } from 'react-bootstrap';
import GeneralForm from '../../profileInfo/components/Forms/GCForm';
import { ROUTES } from '../../profileInfo/constant/Routes';
import { conf } from '../../../confg';
import { set_me } from '../../../actions/user';

const PersonalInformation = ({ firstName, familyName, gender, phone, set_me, hasPassword, nextStep }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const class_toast = 'bg-success';
  const class_toast_error = 'bg-danger';
  const [showErrorToast, setSowErrorToast] = useState(false);
  const [errorMessagae, setErrorMessage] = useState('');
  const [showToast, setShowToast] = useState(false);
  const defaultValue = {
    firstName: firstName ?? '',
    lastName: familyName ?? '',
    phone: phone ?? '',
    gender: gender ?? '',
  };
  const handleToastClose = () => {
    setShowToast(false);
  };
  const handleErrorToastClose = () => {
    setSowErrorToast(false);
  };
  const handleClick = (data) => {
    setIsSubmitting(true);
    let profile_conf = {
      url: conf.server_url + 'auth/update',
      method: 'POST',
      timeout: 0,
      mimeType: 'multipart/form-data',
      contentType: false,
      data: data,
    };

    if (typeof localStorage.getItem('token') !== 'undefined' && localStorage.getItem('token') !== null) {
      profile_conf['headers'] = { Authorization: `Bearer ${localStorage.getItem('token')}` };
    }

    axios(profile_conf)
      .then((res) => {
        console.log('done');
        setShowToast(true);
        set_me();
        nextStep();
      })
      .catch((error) => {
        setIsSubmitting(false);
        setSowErrorToast(true);
        setErrorMessage(error.response.data.message);
      })
      .finally((r) => {
        setIsSubmitting(false);
      });
  };
  return (
    <>
      <div style={{ marginTop: '40px', width: '100%', backgroundColor: 'white', borderRadius: '10px', border: '2px solid #01494b' }}>
        <GeneralForm
          validationSchema={personalInformationValidationSchema}
          FormFieldsComponent={FormFields}
          initialValues={defaultValue}
          submitHandler={(data) => handleClick(data)}
          buttonText='ذخیره'
          buttonLoadingText='در حال ذخیره '
          buttonLoading='test'
          enableReinitialize={true}
          isSubmitting={isSubmitting}
          hasNoBorder={true}
          hasTitle={false}
          shouldBeEnd={true}
        />
      </div>
      <Toast
        className={'rtl position-fixed  color-white z-index-top ' + class_toast}
        style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 999999999999 }}
        show={showToast}
        onClose={handleToastClose}
        autohide={true}
        delay={4000}
      >
        <Toast.Body>اطلاعات شما با موفقیت به روز رسانی شد</Toast.Body>
      </Toast>
      <Toast
        className={'rtl position-fixed  color-white z-index-top ' + class_toast_error}
        style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 999999999999 }}
        show={showErrorToast}
        onClose={handleErrorToastClose}
        autohide={true}
        delay={4000}
      >
        <Toast.Body>{errorMessagae}</Toast.Body>
      </Toast>
    </>
  );
};
const MapStateToProps = (state) => ({
  firstName: state.user.name,
  familyName: state.user.family,
  mobileInfo: state.user.mobile,
  gender: state.user.gender,
  user: state.user,
  phone: state.user.phone,
  hasPassword: state.user.has_password,
});
export default connect(MapStateToProps, { set_me })(PersonalInformation);
